import React, { useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import PageContainer from 'components/PageContainer/PageContainer';
import PoliticasDinamico from './PoliticasDinamico';
import {
  politicaCookies,
  politicaCookiesTitulo,
  politicaPrivacidad,
  politicaPrivacidadTitulo,
  terminosCondiciones,
  terminosCondicionesTitulo,
} from 'utils/constants';
import { useNavigate, useLocation } from 'react-router-dom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const PoliticasPrivacidadDatos = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash === 'terminos') {
      setValue(1);
    } else if (hash === 'cookies') {
      setValue(2);
    } else {
      setValue(0); // Por defecto, la primera tab
    }
  }, [location]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);

    if (newValue === 1) {
      navigate('#terminos');
    } else if (newValue === 2) {
      navigate('#cookies');
    } else {
      navigate('#privacidad');
    }
  };

  return (
    <PageContainer>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="politicas-privacidad" variant="fullWidth" centered>
            <Tab label="Política de Privacidad" />
            <Tab label="Términos de Uso" />
            <Tab label="Política de cookies" />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <PoliticasDinamico titulo={politicaPrivacidadTitulo} textos={politicaPrivacidad} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <PoliticasDinamico titulo={terminosCondicionesTitulo} textos={terminosCondiciones} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <PoliticasDinamico titulo={politicaCookiesTitulo} textos={politicaCookies} />
        </CustomTabPanel>
      </Box>
    </PageContainer>
  );
};

export default PoliticasPrivacidadDatos;
